import { jsx as _jsx } from "react/jsx-runtime";
import { genericNotificationAction } from '../../components/TS_Notifications/index.js';
import { ToastBuilder } from '../../component-modules/ModuleFE_Toaster.js';
import { generateErrorToastContent } from './genereteToasts.js';
const Default_Toast_Duration = 4000;
const Successful_Action_Default_Label = 'Action Preformed Successfully';
const Failed_Action_Default_Label = 'Action Failed';
/**
 * #performAction
 * use this function to execute any async action that requires a feedback.
 * @param action the action to execute.
 * @param feedbackOptions feedback options to determine which kind of feedback to present
 * @param additionalData !Optional! any additional data the notification/toast might need
 * @param throwBackError !Optional! if true, will throw error back outside the action
 */
export async function performAction(action, feedbackOptions, additionalData, throwBackError = false, skipToast = false) {
    switch (feedbackOptions.type) {
        case 'notification':
            if (feedbackOptions.notificationLabels) {
                await genericNotificationAction(action, feedbackOptions.notificationLabels);
            }
            else {
                console.error('cannot use notification as feedback without labels');
            }
            break;
        case 'toast':
            try {
                const content = feedbackOptions.successContent ??
                    _jsx("div", { children: Successful_Action_Default_Label });
                await action();
                new ToastBuilder()
                    .setContent(content)
                    .setDuration(feedbackOptions.duration ?? Default_Toast_Duration)
                    .show();
            }
            catch (err) {
                if (!skipToast) {
                    const content = feedbackOptions.failContent ??
                        _jsx("div", { children: Failed_Action_Default_Label });
                    new ToastBuilder()
                        .setContent(generateErrorToastContent(err, content, additionalData))
                        .setDuration(feedbackOptions.duration ? feedbackOptions.duration : Default_Toast_Duration).show();
                }
                if (throwBackError)
                    throw err;
            }
    }
}
export const asyncHandler = {
    notification: async (title, action) => {
        return genericNotificationAction(action, title);
    },
    toast: {
        simple: async (action, successMessage = Successful_Action_Default_Label, errorMessage = Failed_Action_Default_Label) => {
            try {
                await action();
                new ToastBuilder()
                    .setContent(successMessage)
                    .setDuration(Default_Toast_Duration)
                    .show();
            }
            catch (err) {
                new ToastBuilder()
                    .setContent(errorMessage)
                    .setDuration(Default_Toast_Duration).show();
                throw err;
            }
        },
        onSuccess: async (action, successMessage = Successful_Action_Default_Label) => {
            await action();
            new ToastBuilder()
                .setContent(successMessage)
                .setDuration(Default_Toast_Duration)
                .show();
        }
    }
};
//# sourceMappingURL=performAction.js.map